import apiCall from './apiCall';

export const listPaymentMethods = async () => {
  const resp = await apiCall('GET', '/payment-methods', {}, {});

  return resp.data._embedded["payment-methods"];
}
